import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import PropTypes from "prop-types";

import L from "leaflet";
import "leaflet/dist/leaflet.css";

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import { format } from "date-fns";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

const AttendanceMAP = ({ empAttendanceList }) => {
  const locations = empAttendanceList?.flatMap((emp, empIndex) =>
    emp.attendanceDetails
      .filter((att) => att.loginLatitude !== 0 && att.loginLongitude !== 0)
      .map((att, index) => ({
        id: `${empIndex}-${index}`,
        lat: att.loginLatitude,
        lng: att.loginLongitude,
        name: emp.fullName,
        date: att.attendaceDate,
        inTime: att.inTime,
        outTime: att.outTime,
      })),
  );

  console.log("Locations for Map:", locations);

  return (
    <MapContainer center={[1.27, 103.85]} zoom={10} style={{ height: "500px" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {locations?.map((loc) => (
        <Marker key={loc.id} position={[loc.lat, loc.lng]}>
          <Popup>
            <div>
              <b>{loc.name}</b>
              <br />
              {format(new Date(loc.date), "dd-MM-yyyy")} - {loc.inTime}
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

AttendanceMAP.propTypes = {
  empAttendanceList: PropTypes.array.isRequired,
};

export default AttendanceMAP;
